import { ElementRef, Injectable } from '@angular/core';
import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { DwMessageContainerComponent } from 'ng-quicksilver';
import { NavigationEnd, Router } from '@angular/router';
import { DwMessageDataFilled, DwMessageDataOptions } from 'ng-quicksilver';
import { ComponentPortal } from '@angular/cdk/portal';
import { TranslateService} from '@ngx-translate/core';
import { FxModalService } from 'app/implementation/shared/components/fx-modal/fx-modal.service';

/**
 * https://github.com/angular/angular/issues/20515
 * 子組件使用DwMessageService，報ExpressionChangedAfterItHasBeenCheckedError錯誤
 *
 * 因以上原因，先自己實作
 */


@Injectable()
export class DwRoutingMessageService {
  _container: DwMessageContainerComponent;
  protected _counter = 0; // Id counter for messages
  routedMessages: string[] = [];
  messages: string[] = [];
  _idPrefix = '';

  constructor(private router: Router,
    public fxModalService: FxModalService,
    private translateService: TranslateService,
    private overlay: Overlay) {
    this.router.events
      .subscribe(
      (event) => {
        if (event instanceof NavigationEnd) {
          this._flushRoutedMessage();
        }
      }
      );
  } 
 
 

  addToRoute(content: string): void {
    this.routedMessages.push(content);
  }

  add(content: string): void {
    this.messages.push(content);
  }

  private _flushRoutedMessage(): DwMessageDataFilled {
    if (this.routedMessages.length > 0) {
      const html = this.routedMessages.join('<br/>');
      this.routedMessages.splice(0);
      this.send(html);
    }
    return <DwMessageDataFilled>{};
  }

  flush(options?: DwMessageDataOptions): DwMessageDataFilled {
    if (this.messages.length > 0) {
      const html = this.messages.join('<br/>');
      this.messages.splice(0);
      return this.html(html, options);
    }
    return <DwMessageDataFilled>{};
  }

  // Shortcut methods
  success(content: string, options?: DwMessageDataOptions): DwMessageDataFilled {
    return this.createMessage({ type: 'success', content }, options);
  }

  error(content: string, options?: DwMessageDataOptions): DwMessageDataFilled {
    return this.createMessage({ type: 'error', content }, options);
  }

  info(content: string, options?: DwMessageDataOptions): DwMessageDataFilled {
    return this.createMessage({ type: 'info', content }, options);
  }

  warning(content: string, options?: DwMessageDataOptions): DwMessageDataFilled {
    return this.createMessage({ type: 'warning', content }, options);
  }

  errorNew(content1: string,content2: any,content3: string,content4: string, options?: DwMessageDataOptions): string {
    var returing;
    if(content2=="2"){
      this.fxModalService.confirm({title:this.translateService.instant('com-Message'),message:content1+"\n", programNo: content3, programName: content4,isRemind:true});
      returing ="";
    }else if(content2=="3"){
      this.fxModalService.confirm({title:this.translateService.instant('com-Message'),message:content1+"\n", programNo: content3, programName: content4,isRemind:false});
      returing ="";
    }else if(content2=="4"){
      returing=content1;
    }else{
      this.warning(content1);
      returing ="";
    }
    return returing;
  }

  loading(content: string, options?: DwMessageDataOptions): DwMessageDataFilled {
    return this.createMessage({ type: 'loading', content }, options);
  }

  create(type: string, content: string, options?: DwMessageDataOptions): DwMessageDataFilled {
    return this.createMessage({ type, content }, options);
  }


  /**   以下為實驗性質，搭配<dw-message-holder></dw-message-holder>使用 **/

  html(html: string, options?: DwMessageDataOptions): DwMessageDataFilled {
    return this.createMessage({ html }, options);
  }

  send(content: string): void {
    this.createMessage({ content });
  }

  // 相對於elementRef的位置。但nz自己的.ant-message CSS位置要修正
  setHost(elementRef: ElementRef): void {
    this._setHost(elementRef);
  }

  createMessage(message: object, options?: any): any {
    if (!this._container) {
      this._setHost();
    }
    const resultMessage: any = {
      ...message,
      ...{
        messageId: this._generateMessageId(),
        options,
        createdAt: new Date()
      }
    };
    this._container.createMessage(resultMessage);

    return resultMessage;
  }

  protected _setHost(elementRef?: ElementRef): void {
    let positionStrategy;
    if (elementRef) {
      positionStrategy = this.overlay.position().connectedTo(
        elementRef,
        { originX: 'start', originY: 'bottom' },
        { overlayX: 'end', overlayY: 'top' }
      );
    } else {
      positionStrategy = this.overlay.position().global();
    }
    const overlayRef = this.overlay.create(new OverlayConfig({
      positionStrategy: positionStrategy
    }));
    this._container = overlayRef.attach(new ComponentPortal(DwMessageContainerComponent)).instance;
  }

  protected _generateMessageId(): string {
    return this._idPrefix + this._counter++;
  }

}
